import React from 'react';
import { cssSpacing, screenXsMax, screenSmMax, screenSmMin, titleMedium, KeyboardDetectionProvider, } from '@spotify-internal/encore-web';
import { ColorSetWrapper } from '../../ui/Colors/Colors';
import { Grid } from '../../ui';
import styled from 'styled-components';
import { ContentfulImage } from '../../ui';
import { ImageAspectBox16x9, SectionHeader } from '../../ui';
import { transformScaleUp } from '../../ui/utils';
import { hexToRgba } from '../../ui/colorConversion';
import { LinkGrid } from '../../ui';
import { useFrodorModules } from '../../Context/FrodorModulesProvider';
const Hero = styled(Grid) `
  display: flex;
  flex-direction: row;
  padding-top: ${cssSpacing('looser-4')};
  padding-bottom: ${cssSpacing('looser-4')};
  color: ${({ color }) => color} !important;
  background-color: ${({ background }) => background};

  &:hover {
    p,
    h1 {
      color: ${props => props.color ? hexToRgba(props.color, 0.75) : props.color} !important;
    }
    img {
      ${transformScaleUp};
      transition: transform 0.3s ease-in-out;
    }
  }

  @media (max-width: ${screenXsMax}) {
    flex-direction: column;
  }
`;
const ImageContainer = styled(ImageAspectBox16x9) `
  height: 100%;
  width: 120%;
  order: 3;
  overflow: hidden;

  @media (max-width: ${screenXsMax}) {
    width: 100%;
    order: 2;
  }
`;
const TextContainer = styled.div `
  order: 2;
  padding-right: ${cssSpacing('looser-4')};
  align-self: center;
  height: 100%;
  width: 80%;

  @media (max-width: ${screenXsMax}) {
    padding-top: ${cssSpacing('base')};
    width: 100%;
    order: 3;
  }
`;
const ModuleWrapper = styled.div `
  padding-block-end: ${cssSpacing('looser-3')};

  /* Two column (tablet) grid */
  @media (min-width: ${screenSmMin}) and (max-width: ${screenSmMax}) {
    padding-block-end: ${cssSpacing('looser-3')};
  }
`;
const TRACK_CAT = 'module-featuredContent';
const FeaturedContent = styled.div `
  grid-column: 1 / -1;

  & > div > div,
  ul {
    padding-bottom: 0;
  }

  & > div > div > ul > li {
    margin-bottom: ${cssSpacing('looser')};
  }

  & > div:first-child > div > p {
    ${titleMedium}
    letter-spacing: -1.28px;
    text-transform: none;
    padding-top: ${cssSpacing('tighter-2')};
  }
  .hero {
    color: ${({ color }) => color} !important;
    text-decoration: none;
    @media (max-width: ${screenSmMax}) {
      & h1 {
        line-height: 36px;
      }
    }

    &&:hover:not(:disabled),
    &&:focus:not(:disabled) {
      color: ${({ color }) => color ? hexToRgba(color, 0.75) : color} !important;
    }
  }
`;
const GridWrapper = styled(Grid) `
  box-sizing: border-box;
  padding-top: ${cssSpacing('looser-3')};
`;
export const FeaturedContentModule = React.forwardRef(({ color = '', background = '', caption = '', gridSupertext = '', heroSupertext = '', contentItems, hero, theme, }, ref) => {
    const { InteractiveElement } = useFrodorModules();
    let colors;
    if (theme === 'whiteOnBlack') {
        colors = {
            backgroundColor: '#000000',
            textColor: '#FFFFFF',
        };
    }
    else {
        colors = {
            backgroundColor: '#FFFFFF',
            textColor: '#000000',
        };
    }
    return (React.createElement(KeyboardDetectionProvider, null,
        React.createElement(ColorSetWrapper, { colors: colors },
            React.createElement(GridWrapper, { ref: ref, fullBleed: true },
                React.createElement(FeaturedContent, { color: color },
                    React.createElement(ModuleWrapper, { ref: ref },
                        React.createElement(LinkGrid, { subtext: gridSupertext.toUpperCase(), items: contentItems, trackCategory: TRACK_CAT, placeholders: true, featured: false })),
                    hero && hero.url && (React.createElement(InteractiveElement, { className: "hero", href: hero.url, trackingCategory: TRACK_CAT, trackingLabel: `CTA Link - ${hero.title}` },
                        React.createElement(Hero, { color: color, background: background },
                            React.createElement(TextContainer, null,
                                React.createElement(SectionHeader, { eyebrow: heroSupertext, heading: hero.title })),
                            React.createElement(ImageContainer, null, hero.image && (React.createElement(ContentfulImage, { asset: hero.image, caption: caption })))))))))));
});
